import { Button } from 'react-bootstrap';
import { formatDateTime } from 'utils/dates/date.utils';
import { FEMA_STATUS_CHANNEL_LABELS } from '../../AlertCreator/components/IpawsAlertFields/config/femaStatusCodes';
import FemaFullDetail from './FemaFullDetail';
import FemaOptions from './FemaOptions';

/**
 * Renders one version in the FEMA message history timeline.
 *
 * @param {{ version: object, isExpanded: boolean, setExpandedVersionId: Function, alert: object }} props
 * @returns {JSX.Element} The FEMA history item.
 */
const FemaHistoryItem = ({ version, isExpanded, setExpandedVersionId, alert }) => {
  const result = version.sendResult;

  return (
    <article className="border rounded-1 p-2">
      <div className="d-flex align-items-start justify-content-between gap-2">
        <button
          type="button"
          className="btn btn-link text-start p-0 text-decoration-none text-body"
          onClick={() => setExpandedVersionId(isExpanded ? null : version.id)}
          aria-expanded={isExpanded}
        >
          <div className="d-flex flex-wrap gap-2 align-items-baseline">
            <strong>{version.payload.msgType}</strong>
            <span>{formatDateTime(version.envelope.sent)}</span>
          </div>
        </button>
        <div className="d-flex align-items-center gap-2">
          <Button
            type="button"
            variant="outline-secondary"
            size="sm"
            className="text-decoration-none"
            style={{ color: 'var(--color-link)', borderColor: 'var(--color-link)' }}
            onClick={() => setExpandedVersionId(isExpanded ? null : version.id)}
          >
            {isExpanded ? 'Close' : 'Open'}
          </Button>
          <FemaOptions alert={alert} />
        </div>
      </div>

      {isExpanded && (
        <div className="mt-3">
          {version.payload?.info?.length ? (
            <div className="d-flex flex-column gap-3">
              {version.payload.info.map((info, infoIndex) => (
                <FemaFullDetail
                  key={`${version.id}-info-${infoIndex}`}
                  info={info}
                  version={version}
                />
              ))}
            </div>
          ) : null}
          {result?.advisories?.length ? (
            <div className="mt-3">
              <div className="fw-semibold small mb-1">Advisories</div>
              <ul className="mb-0 mt-2 ps-3 small">
                {result.advisories.map((advisory) => (
                  <li key={`${version.id}-${advisory.channel}-${advisory.code}`}>
                    <strong>{advisory.code}</strong>{' '}
                    {FEMA_STATUS_CHANNEL_LABELS[advisory.channel] ?? advisory.channel}:{' '}
                    {advisory.backendMessage || advisory.remark}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      )}
    </article>
  );
};

export default FemaHistoryItem;
